/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DocumentScopeEnum = {
    Quote: 'Devis',
    Contract: 'Contrat',
    Product: 'Produit',
    Amendment: 'Avenant',
    Receipt: 'Quittance',
    Broker: 'Courtier',
    System: 'System',
    Tenant: 'Locataire',
    Subscriber: 'Souscripteur',
    BorrowerProject: 'ProjetEmprunt'
} as const;
export type DocumentScopeEnum = typeof DocumentScopeEnum[keyof typeof DocumentScopeEnum];


export function instanceOfDocumentScopeEnum(value: any): boolean {
    for (const key in DocumentScopeEnum) {
        if (Object.prototype.hasOwnProperty.call(DocumentScopeEnum, key)) {
            if (DocumentScopeEnum[key as keyof typeof DocumentScopeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DocumentScopeEnumFromJSON(json: any): DocumentScopeEnum {
    return DocumentScopeEnumFromJSONTyped(json, false);
}

export function DocumentScopeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentScopeEnum {
    return json as DocumentScopeEnum;
}

export function DocumentScopeEnumToJSON(value?: DocumentScopeEnum | null): any {
    return value as any;
}

export function DocumentScopeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DocumentScopeEnum {
    return value as DocumentScopeEnum;
}

